import React from 'react'
import { ActionsContainer } from './CarpayOrderActions.style'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { useTranslation } from 'react-i18next'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'

const StayOrLeaveActions = ({ onLeave, onStay }: { onLeave: () => void; onStay: () => void }) => {
    const { t } = useTranslation()

    return (
        <ActionsContainer>
            <Button id="stay-button" $kind={BUTTON_KIND.primary} onClick={onStay} $size={BUTTON_SIZE.medium}>
                {t('carpay.orderActions.stay')}
            </Button>

            <Button id="leave-button" $kind={BUTTON_KIND.primary} onClick={onLeave} $size={BUTTON_SIZE.medium}>
                {t('carpay.orderActions.leave')}
            </Button>
        </ActionsContainer>
    )
}

export default StayOrLeaveActions
